/**
 * @file teacher
 * @author 陈恩浩
 */

import React, { Component } from "react";
import "./index.scss";

class WhyHatu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    let numList = [
      {
        flag: 2,
        count: 5,
        text: "层层筛选，不到5%的通过率 只为给孩子最好的中文老师",
      },
      {
        flag: 2,
        count: 100,
        text: "哈兔老师们均有本科及以上学历 拥有权威教师资格证，以及两年以上的教学经验",
      },
      { flag: 1, count: 3000, text: "哈兔在线老师超过3000人 总有适合您的那位" },
    ];
    return (
      <div className="home-teacher">
        <div className="inner">
          <div className="inner-title" style={{ marginBottom: "20px" }}>
            中文教育专家
          </div>
          <ul className="number">
            {numList.map((item, index) => (
              <li key={"count-" + index}>
                {item.flag === 1 ? (
                  <div>{item.count}+</div>
                ) : (
                  <div>{item.count}%</div>
                )}
                <div
                  style={{
                    width: "290px",
                    fontSize: "16px",
                    lineHeight: "24px",
                  }}
                >
                  {item.text}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default WhyHatu;
